import { yupResolver } from "@hookform/resolvers/yup";
import { StackScreenProps } from "@react-navigation/stack";
import { Page, TextField, Button } from "@towersystems/roam-common-native";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { SettingsRootParamList } from "../../../../types";
import { useLocalSettingsProvider } from "../../../../utilities/local-settings";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import {
  useGlobalSettingsProvider,
  useMutationUpdateGlobalSettings,
} from "../../../../utilities/global-settings/hooks";
import React from "react";

export interface EditEndOfShiftDestinationEmailScreenProps
  extends StackScreenProps<
    SettingsRootParamList,
    "EditEndOfShiftDestinationEmailScreen"
  > {}

export const EditEndOfShiftDestinationEmailScreen = ({
  navigation,
}: EditEndOfShiftDestinationEmailScreenProps) => {
  const shouldFocus = useHasTransitionEnded(navigation);
  const { updateGlobalSettings } = useMutationUpdateGlobalSettings();

  const globalSettings = useGlobalSettingsProvider();
  const { terminalClosureSendToAddress = "" } = globalSettings;
  const [value, setValue] = React.useState(terminalClosureSendToAddress || "");

  const isValid = React.useMemo(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  }, [value]);

  const isDirty = React.useMemo(() => {
    return value != terminalClosureSendToAddress;
  }, [value, terminalClosureSendToAddress]);

  const handleOnSave = React.useCallback(async () => {
    if (!isValid) return;
    return updateGlobalSettings({
      terminalClosureSendToAddress: value,
    })
      .then((e) => navigation.goBack())
      .catch((err) => console.log(err));
  }, [value, isValid]);

  useEffect(() => {
    navigation.setOptions({
      headerTitleAlign: "center",
      headerTitle: "End of Shift Email Address",
      headerStatusBarHeight: 10,
      headerRight: () => {
        return (
          <Button
            label="Save"
            isAction
            disabled={!isValid || !isDirty}
            onPress={handleOnSave}
            size="compact"
          ></Button>
        );
      },
    });
  }, [isValid, isDirty, handleOnSave]);

  return (
    <Page scrollable={false} cover>
      <TextField
        placeholder="Send to Address"
        value={value}
        onChangeText={(v) => setValue(v)}
        autoFocus={shouldFocus}
      />
    </Page>
  );
};
